import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvConfig } from "src/environments/environment";
import { Cig } from "./cig.model";
import { Health } from "./health.model";
import { JWT } from "./jwt.model";
import { Comune, Provincia, Regione } from "./localizzazione.model";
import { PersonaGiuridica, PersoneGiuridiche } from "./persona-giuridica.model";
import { ProtocolloResponse } from "./protocollo.model";
import { RestDataSource } from "./rest.datasource";
import { SottomissioneReqBody } from "./sottmissione-post.model";
import { TranscodeResponse } from "./transocode.model";

@Injectable()
export class SegnalazioniRepository {

    private cig: Cig = new Cig();
    private personaGiuridica: PersonaGiuridica = new PersonaGiuridica();
    private personeGiuridiche: PersoneGiuridiche = new PersoneGiuridiche();

    constructor(private datasource: RestDataSource) {

    }

    getResponseWaitPG(cf: string, jwt: string):Promise<PersonaGiuridica> {
        return this.datasource.getInfoFromSAWait(cf, jwt);
    }

    getResponseWaitPGLike(cf: string, jwt: string):Promise<PersoneGiuridiche> {
        return this.datasource.getInfoFromSALikeWait(cf, jwt);
    }

    getResponseWaitCig(codice_cig: string, jwt: string) :Promise<Cig> {
        return this.datasource.getInfoFromCigWait(codice_cig, jwt);
    }

    getResponseWaitRegioneFromProvincia(provincia: string, comune: string, jwt: string) :Promise<Regione> {
        return this.datasource.getRegioneFromProvincia(provincia, comune, jwt);
    }

    getResponseWaitRegioneFromIstat(codice: string, jwt: string) :Promise<Regione> {
        return this.datasource.getRegioneFromIstat(codice, jwt);
    }
    getResponseWaitProvinciaFromIstat(codice: string, jwt: string) :Promise<Provincia> {
        return this.datasource.getProvinciaFromIstat(codice, jwt);
    }
    getResponseWaitComuneFromIstat(codice: string, jwt: string) :Promise<Comune> {
        return this.datasource.getComuneFromIstat(codice, jwt);
    }

    getResponseWaitProtocollo(id: string, jwt: string) : Promise<ProtocolloResponse> {
        return this.datasource.getSubmissionInvoice(id,jwt);
    }

    getResponseWaitAmbito(code: string, oggetto: string, jwt: string) : Promise<TranscodeResponse> {
        return this.datasource.getAmbito(code,oggetto,jwt);
    }

    getResponseWaitContraente(code: string, jwt: string) : Promise<TranscodeResponse> {
        return this.datasource.getContraente(code,jwt);
    }

    postResponseWaitSottomissione(idSottomissione: string, idProtocollo: string, jwt: string) : Promise<void> {
        var srb = new SottomissioneReqBody();
        srb.idSottomissione=idSottomissione;
        srb.protocollo=idProtocollo;
        return this.datasource.postSottomissione(srb,jwt);
    }

    health():Promise<Health> {
        return this.datasource.getHealthService();
    }

    authenticate():Promise<JWT> {
        return this.datasource.autheticate(EnvConfig.jwt_user, EnvConfig.jwt_password);
    }

  downloadReportPdf(id: string) : Promise<any> {
    return this.datasource.getReportPdf(id);
  }
}
